export function noop(val: any): any {
  return val;
}

export function noopVoid() {
  return;
}
